{
  "version": 1,
  "asset_id": "9689fbbe-cc00-4f15-8d15-9d12e5e5ed62",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9689fbbe-cc00-4f15-8d15-9d12e5e5ed62/floral-city-black-shingle-roof-installation-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9689fbbe-cc00-4f15-8d15-9d12e5e5ed62/floral-city-black-shingle-roof-installation-480w.webp",
  "original_filename": "floral-city-black-shingle-roof-installation-480w.webp",
  "size": 24410,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
